import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFriendsOfDwf from "../../lib/hooks/use-friends-of-dwf";

const fallbackPartners = [
  {
    name: "All",
    slug: "all",
    label: "All",
    textClass: "text-3xl",
  },
  {
    name: "ReelCanada",
    slug: "reelcanada",
    label: "ReelCanada",
    textClass: "text-lg",
  },
  {
    name: "Métis Nation-Saskatchewan",
    slug: "metis-nation-saskatchewan",
    label: "Métis Nation-Saskatchewan",
    textClass: "text-base",
  },
  {
    name: "Connected North",
    slug: "connected-north",
    label: "Connected North",
    textClass: "text-xl",
  },
  {
    name: "Kids Help Phone",
    slug: "kids-help-phone",
    label: "Kids Help Phone",
    textClass: "text-xl",
  },
  {
    name: "Girl Guides",
    slug: "girl-guides",
    label: "Girl Guides",
    textClass: "text-xl",
  },
];

export default function FriendsofDWFPage() {
  const { isLoading, partnerSummaries } = useFriendsOfDwf();
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setHasLoaded(true);
    }
  }, [isLoading]);

  const partners = partnerSummaries.length > 0 ? partnerSummaries : fallbackPartners;
  const showSkeleton = isLoading && !hasLoaded;

  return (
    <main className="friends-of-dwf-page page bg-white">
      <div className="max-w-6xl mx-auto px-4 py-10">
        <h1 className="flex text-5xl font-semibold text-gray-800 portrait:text-3xl lg:text-5xl md:text-5xl sm:text-3xl ps-6 py-6">
              Friends of DWF</h1>
        <section className="token-surface-partner-rail rounded-[28px] p-6 sm:p-8 md:p-10 shadow-sm">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {showSkeleton
              ? Array.from({ length: 6 }).map((_, index) => (
                  <div
                    key={`skeleton-${index}`}
                    className="bg-white/80 rounded-[36px] border border-white/70 shadow-sm aspect-square animate-pulse"
                  >
                    <div className="h-full p-6" />
                  </div>
                ))
              : partners.map((partner) => {
                  const label = "label" in partner ? partner.label : partner.name;
                  const textClass = "textClass" in partner ? partner.textClass : "text-xl";
                  const logoUrl = "logoUrl" in partner ? partner.logoUrl : undefined;

                  return (
                    <Link
                      key={partner.slug}
                      to={`/app/friends-of-dwf/${partner.slug}`}
                      aria-label={`Open partner page: ${label}`}
                      className={`group h-full transition-opacity duration-500 ease-out ${hasLoaded ? "opacity-100" : "opacity-0"}`}
                    >
                      <div className="bg-white rounded-[36px] border border-white/70 shadow-sm transition-all duration-200 group-hover:shadow-[0_10px_24px_rgba(15,23,42,0.12)] group-hover:-translate-y-1 aspect-square">
                        <div className="h-full p-6 flex items-center justify-center text-center">
                          {logoUrl ? (
                            <>
                              <img
                                src={logoUrl}
                                alt={`${label} logo`}
                                className="max-h-full max-w-full h-auto w-auto object-contain"
                                loading="lazy"
                              />
                              <span className="sr-only">{label}</span>
                            </>
                          ) : (
                            <p className={`${textClass} font-semibold text-gray-700 leading-tight max-w-[14rem]`}>
                              {label}
                            </p>
                          )}
                        </div>
                      </div>
                    </Link>
                  );
                })}
          </div>
        </section>
      </div>
    </main>
  );
}
